import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, requiredPayloadEnvelope } from '../envelope.js';
const c = initContract();
export const topDonorsPeriodSchema = z.enum(['today', '7d', '30d']);
export const topDonorRankItemSchema = z.object({
    rank: z.number().int().positive(),
    provider: z.string(),
    donorPlatformUserId: z.string(),
    donorDisplayName: z.string(),
    unit: z.string(),
    totalQuantity: z.number(),
    eventCount: z.number().int().nonnegative(),
});
export const topDonorsPayloadSchema = z.object({
    period: topDonorsPeriodSchema,
    windowStart: z.string(),
    windowEnd: z.string(),
    todayDate: z.string(),
    rollupDates: z.array(z.string()),
    livePartial: z.boolean(),
    items: z.array(topDonorRankItemSchema),
});
/** 오늘 live 순위 응답에 권장하는 Cache-Control max-age(초). */
export const TOP_DONORS_CACHE_MAX_AGE_SECONDS = 45;
export const adminAnalysisContract = c.router({
    listTopDonors: {
        method: 'GET',
        path: '/analysis/top-donors',
        query: z.object({
            period: topDonorsPeriodSchema.optional().default('today'),
            limit: z.coerce.number().int().positive().max(200).optional().default(50),
        }),
        responses: {
            200: requiredPayloadEnvelope(topDonorsPayloadSchema),
            ...commonErrorResponses,
        },
        summary: '수집 중 방송 기준 큰손(후원자) 순위 — 오늘 live + N일 롤업',
    },
});
//# sourceMappingURL=analysis.contract.js.map